import { render, staticRenderFns } from "./AdminPricingPlans.vue?vue&type=template&id=0af5f77a"
import script from "./AdminPricingPlans.vue?vue&type=script&lang=js"
export * from "./AdminPricingPlans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-api/api.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0af5f77a')) {
      api.createRecord('0af5f77a', component.options)
    } else {
      api.reload('0af5f77a', component.options)
    }
    module.hot.accept("./AdminPricingPlans.vue?vue&type=template&id=0af5f77a", function () {
      api.rerender('0af5f77a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/AdminPricingPlans.vue"
export default component.exports